// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1WwVb","subheader":"ReorderModal_subheader__3HY0e","listWrap":"ReorderModal_listWrap__30Jtw"};